import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ModifiedSessionDocumentInfo } from '../models';

export function creditMemoSelection(): ValidatorFn {
  return (
    control: AbstractControl<ModifiedSessionDocumentInfo[]>,
  ): ValidationErrors | null => {
    if (control.value == null || control.value.length === 0) {
      return null;
    }

    const validationError = { creditMemoSelection: true };

    if (control.value.every((doc) => doc.isCreditMemo)) {
      return validationError;
    }

    return null;
  };
}
